import styled from "styled-components"

const Container = styled.div`
  font-weight: var(--font-weight-sm);
  font-size: var(--font-size-sm);
  color: ${({theme}) => theme.mainTextColor};
h4{
  font-weight: var(--font-weight-lg);
  font-size: var(--font-size-sm);
  color: ${({theme}) => theme.mainTextColor};
}


.list{
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 30px;
  width: 70%;
  gap: 10px;

  .list-item{
    display: flex;
    flex-direction: column;
  }

}


  .seperator{
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.contrastBorderColor};
  }
`

const AracDetails = ({aracData}) => {
  return (
    <Container>
      {
        (aracData?.aracSayisi || aracData?.aracTypeName || aracData?.zeminType?.text) &&
          <>
            <h4 className="title">Araç</h4>
            <div className="list">
              {
                aracData?.aracSayisi &&
                <div className="list-item">{`${aracData?.aracSayisi} Adet`}</div>
              }
              {
                (aracData?.aracTypeName || aracData?.kasaTypeName) &&
                <div className="list-item">{aracData?.aracTypeName} {aracData?.kasaTypeName}</div>
              }
              {
                aracData?.zeminType &&
                <div className="list-item">{aracData?.zeminType?.text}</div>
              }
            </div>
            <div className="seperator"/>
          </>
        }
    </Container>
  )
}

export default AracDetails